import React from 'react';
import Header from '~/components/header';
import Footer from '~/components/footer';
import Loading from '~/components/loading/loading';
import NotFound from '~/components/not-found/index';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as currencyFormatter from 'currency-formatter';

import { getMessage, system_lang, convertCentsToFloat } from '~/assets/utils';
import {
    getProductsOrders
} from '../../assets/requests/product';
import { getFirebaseData } from '~/firebase/functions';
import moment from 'moment';

class ShoppingHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message_load: 'loading_products',
            loaded: false,
            orders: [],
            attributes: [],
            total_price: 0,
            zip_code: '',
            orders_available: false,
            fare_price: 0,
            colors: [],
            colorsAttributes: [],
            userData: {
                isCnpj: false
            }
        }

        this.getProductsOrders = async () => {
            let response = await getProductsOrders();
            if (response.status === true) {
                this.setState({ orders: response.orders, attributes: response.attributes, total_price: response.total_price });
            }
            this.setState({ message_load: 'all_is_ready', loaded: true });
        }
        this.seeProduct = (product_id, e) => {
            e.preventDefault();
            this.props.history.push('/product/' + product_id);
        }
        this.doPaymentOrder = async (order_id) => {
            try {
                const orders = Object.assign([], this.state.orders);
                let indexOf = orders.findIndex(item => item._id === order_id);
                if (indexOf >= 0) {
                    let dataPayment = {};
                    const order = orders[indexOf];
                    dataPayment.deliveryMode = order.deliveryMode;
                    dataPayment.total_price = order.totalPrice - order.fare;
                    dataPayment.zip_code = order.deliveryAddress.zip_code;
                    dataPayment.fare_price = order.fare;
                    dataPayment.farePrice = order.fare;
                    dataPayment.national_identification = '';
                    dataPayment.national_identification_email = '';
                    dataPayment.national_identification_name = '';
                    dataPayment.complement = order.deliveryAddress.additional;
                    dataPayment.street = order.deliveryAddress.address;
                    dataPayment.city = order.deliveryAddress.city;
                    dataPayment.district = order.deliveryAddress.district;
                    dataPayment.number = order.deliveryAddress.number;
                    dataPayment.state = order.deliveryAddress.state;
                    this.props.dispatch({ type: 'SET_FREIGHT_DATA', data: dataPayment })
                    this.props.history.push('/payment?history=' + order_id);
                }
            }
            catch (error) {
                return false;
            }
        }
        /**
         * Pega o nome de uma cor
         * @param {*} attributeKey 
         */
        this.getColorName = (colorKey) => {
            try {
                const { colors } = this.state;
                if (!colors) return false;
                const color = colors.find(item => item.colorKey === colorKey);
                if (color) {
                    return color.name;
                }
                else {
                    return 'Não informada';
                }
            }
            catch (error) {
                return 'Não informada';
            }
        }
        /**
         * Renderiza as cores de cada atributo
         * @param {*} item 
         * @param {*} key 
         */
        this.renderAttributeColor = (item, attributes, listAttributes, productId, key) => {
            try {
                let html = [];
                listAttributes.map((attribute, position) => {
                    let quantity = 0;
                    const indexOf = attributes.findIndex(item2 => item2.childrenKey === attribute.childrenKey && item2.colorKey === item.colorKey);
                    if (indexOf >= 0) quantity = attributes[indexOf].quantity;

                    html.push(
                        <div style={{
                            width: '100%',
                            maxWidth: '110px'
                        }} key={position}>
                            <div className='counter d-flex mb-0' style={{
                                background: '#e7e7e7',
                                borderRight: 'solid 1px #cecece',
                                height: '100%',
                                borderBottom: 'solid 1px #cecece'
                            }}>
                                <div className='counter-total m-auto' style={{ background: '#e6e6e6', width: '100%' }}>
                                    <input
                                        type='number'
                                        style={{maxWidth: '100%', margin: 'auto'}}
                                        value={quantity}
                                        name={new Date().getTime()}
                                        readOnly={true} />
                                </div>
                            </div>
                        </div>
                    )
                });
                return html;
            }
            catch (error) {
                return '';
            }
        }
        /**
         * Carrega os atributos
         */
        this.renderAttributes = (attributes, productId, colors) => {
            try {
                if (!attributes) return false;

                let listAttributes = [];
                attributes.map(item => {
                    const indexOf = listAttributes.findIndex(item2 => item2.childrenKey === item.childrenKey);
                    if (indexOf < 0) listAttributes.push(item);
                })

                return (
                    <div className='attribute-wrapper'>
                        <div className='row'>
                            <div className='col-12 col-lg-12 pl-lg-0'>
                                <div className='row table' style={{ zoom: '75%' }}>
                                <div className='header-table col-12'>
                                        <div className='row'>
                                            <div className='col-2'></div>
                                            <div className='col-10'>
                                                <div className='row'>
                                                    {listAttributes.map((item, key) => {
                                                        return (<div className='item-header' key={key}>{item.childrenName}</div>)
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='body-table col-12'>
                                        <div className='row'>
                                            <div className='col-2'>
                                                {colors.map((item, key) => {
                                                    return (<div className='item-body' key={key}>{item.name}</div>)
                                                })}
                                            </div>
                                            <div className='col-10'>
                                                {colors.map((item, key) => {
                                                    return (
                                                        <div className='row' style={{height: '44.5px'}} key={key}>
                                                            {this.renderAttributeColor(item, attributes, listAttributes, productId, key)}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            catch (error) {
                return false;
            }
        }
        this.loadProduct = () => {
            let order_list = [];
            const { orders } = this.state
            orders.map((order, key) => {
                let products_list = [];
                let products = [];
                order.products.forEach(item => {
                    const indexOf = products.findIndex(item2 => item2._id === item._id);
                    if (indexOf >= 0) {
                        products[indexOf].details.push(item.details);
                    }
                    else {
                        products.push({
                            ...item,
                            details: [item.details]
                        })
                    }
                });
                products.map((product, key) => {
                    products_list.push(
                        <div className='history-product row mb-4 pt-4' key={key}>
                            <div className='col-12 col-md-6'>
                                <div className='media m-auto d-flex flex-wrap'>
                                    <a className='thumbnail pull-left d-block d-lg-inline-block col-12 col-lg-3 text-center' href={process.env.REACT_APP_URL + '/product/' + product._id} onClick={(e) => this.seeProduct(product._id, e)}>
                                        <img className='media-object img-fluid' alt={process.env.REACT_APP_NAME} src={product.images[0].url} />
                                    </a>
                                    <div className='media-body col-12 col-lg-9 text-center text-lg-left'>
                                        <h4 className='media-heading'>
                                            <a href={process.env.REACT_APP_URL + '/product/' + product._id} onClick={(e) => this.seeProduct(product._id, e)}>{product.name}</a>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className='col-10 ml-auto mr-auto mb-4 md-md-0'>
                                <div className='product-details'>
                                    <div className='name-attribute'>
                                        {this.renderAttributes(product.details, product._id, product.colors)}
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6'>
                                <div className='row align-items-center'>
                                    <div className='col-6 col-sm-auto col-md-6 col-lg-6 col-xl-auto order-1 order-sm-1 order-md-1 order-lg-1 order-xl-2 mb-lg-2 mb-3 mb-xl-0 text-center'>
                                        <span className='d-inline'>{getMessage('price')}: </span>
                                        <strong>{product.price && currencyFormatter.format(convertCentsToFloat(product.price), { locale: system_lang })}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                });
                order_list.push(
                    <div className='container-order' key={key}>
                        {products_list}
                        <div className='details-order'>
                            <div className='details-order-item'>
                                {getMessage('order_time')}: {moment(new Date(order.createdAt)).format('DD/MM/YYYY')}
                            </div>
                            <div className='details-order-item'>
                                {getMessage('order_number')}: {order.orderNumber || 0}
                            </div>
                            <div className='details-order-item mb-2'>
                                Status: {order.status === 0 && getMessage('order_canceled')}
                                {order.status === 1 && getMessage('order_pending')}
                                {order.status === 2 && getMessage('order_scheluded')}
                                {order.status === 3 && getMessage('order_finished')}
                            </div>
                            {/**<div className='details-order-item strong'>
                                {getMessage('fare')}: {currencyFormatter.format(convertCentsToFloat(order.fare), { locale: 'pt-BR' })}
                            </div>**/}
                            <div className='details-order-item strong'>
                                {getMessage('discount')}: {currencyFormatter.format(convertCentsToFloat(order.discount + (order.discountPercentage || 0)), { locale: 'pt-BR' })}
                            </div>
                            <div className='details-order-item strong'>
                                {getMessage('total')}: {currencyFormatter.format(convertCentsToFloat(order.totalPrice - (order.discount + (order.discountPercentage || 0))), { locale: 'pt-BR' })}
                            </div>
                            {this.state.userData.isCnpj === false &&
                                <div className='details-order-item mb-2'>
                                    {order.status === 1 && <button className='btn btn-danger mt-3' onClick={() => this.doPaymentOrder(order._id)}>{getMessage('do_payment')}</button>}
                                </div>}
                        </div>
                    </div>
                );
                return true;
            });
            return order_list;
        }
        this.goToHome = () => {
            this.props.history.push('/');
        }
        this.userSession = async () => {
            let userData = await getFirebaseData(`users/${localStorage.getItem('user_id')}`);
            if (userData.status === true) {
                this.setState({ userData: userData.data });
            }
            this.setState({ user: this.props.user });
        }
        this.seePayment = async () => {
            this.props.history.push('/payment');
        }
    }

    /**
     * Carrega as cores do produto
     */
    loadColors = async () => {
        let response = await getFirebaseData(`colors`);
        if (response.status === true) {
            response = response.data;
            let colors = [];
            if (response) {
                Object.keys(response).map(colorKey => {
                    colors.push({
                        colorKey: colorKey,
                        ...response[colorKey]
                    })
                });
            }
            this.setState({ colors: colors });
        }
    }

    componentDidMount() {
        document.querySelector('body').classList.remove('scroll-false');
        this.userSession();
        this.loadColors();
        this.getProductsOrders();
    }

    componentDidUpdate(prevProps) {
        for (let key in this.props) {
            if (this.state.hasOwnProperty(key) && (this.props[key] !== prevProps[key])) {
                const state = Object.assign({}, this.state);
                state[key] = this.props[key];
                this.setState(state);
            }
        }
        if (prevProps.logged !== this.props.logged) {
            this.setState({
                logged: this.props.logged
            })
        }
    }

    render() {
        require('./css/history.css');
        const { message_load, loaded, orders } = this.state;
        return (
            <Loading message={message_load} loaded={loaded}>
                <div className={`history-container container-fluid mt-5 pt-md-4 pb-4 mb-5 ${loaded === true && 'show'}`}>
                    <main className='h-100'>
                        <div className='wrapper-table-history'>
                            {orders.length > 0 && this.loadProduct()}
                            {orders.length === 0 && <NotFound title='none_order' description='have_not_order' />}
                        </div>
                    </main>
                </div>
            </Loading>
        )
    }
}
export default withRouter(connect(store => ({ products: store.products, user: store.user }))(ShoppingHistory));